import type { Page } from '@playwright/test'
import { tokenResult } from '../fixtures/data'

/**
 * Mock Keycloak authentication for Playwright tests
 * This sets up window.CYPRESS to trigger the MockKeycloak in the application
 */
export class MockKeycloak {
  authenticated = true
  token = tokenResult.access_token
  refreshToken = tokenResult.refresh_token
  idToken = tokenResult.id_token
  tokenParsed = {
    exp: 1748350308,
    iat: 1748348508,
    auth_time: 1748348014,
    jti: '9f56718d-3b5f-4d13-9490-ba68d6c750ec',
    iss: 'https://id.au.test.tomra.cloud/auth/realms/TomraConnectUsers',
    aud: [
      'account-management',
      'mytomra-api',
      'voucher-control-api',
      'assortment-management-api',
      'barcode-manager-api',
      'mytomra-charity-api',
      'account'
    ],
    sub: 'e4b48a6f-6aff-4f4b-8099-298b12e6a4ff',
    typ: 'Bearer',
    azp: 'mytomra-charity-manager-ui',
    sid: '14dbc360-d4e4-4a4a-b989-537bedc580be',
    acr: '0',
    'allowed-origins': [
      'https://mytomra-hotline.au.test.tomra.cloud',
      '*',
      'https://au.test.mytomra-manager.tomra.cloud'
    ],
    scope: 'openid profile email',
    email_verified: true,
    scoped_resource_access: ['DeveloperPortal#User#d733e985-ed1a-4b4f-bcf7-378dd2378c3c#DEVELOPER_PORTAL_READ'],
    name: 'Elin Sunde Wilberg',
    preferred_username: 'elin.sunde.wilberg@tomra.com',
    given_name: 'Elin Sunde',
    family_name: 'Wilberg',
    full_resource_access: [
      'ACCOUNT_ADMIN',
      'LIST_INSTALLATIONS_FOR_USER',
      'LIST_ACTIVE_USERS_FOR_PRODUCT',
      'LIST_API_PRODUCTS_FOR_USER',
      'INSTALLATION_HAS_ACTIVE_LICENSE_ON_PRODUCT',
      'MYTOMRA_MANAGER_BAGS',
      'MYTOMRA_MANAGER_NOTES_WRITE',
      'MYTOMRA_MANAGER_WRITE',
      'MYTOMRA_EXTERNAL_LOCATION_WRITE',
      'MYTOMRA_BACKOFFICE_READ',
      'VOUCHER_CONTROL_ADMIN_MACHINE_SEARCH',
      'VOUCHER_CONTROL_ADMIN',
      'VOUCHER_CONTROL_ADMIN_STATISTICS_SEARCH',
      'VOUCHER_CONTROL_ADMIN_MANAGE_SOAP_CLIENTS',
      'VOUCHER_CONTROL_ADMIN_EXPORT_RECEIPT',
      'WRITE_COMMON_ASSORTMENT',
      'VIEW_ASSORTMENT_MANAGEMENT',
      'WRITE_INSTALLATION_ASSORTMENT',
      'WRITE_ASSORTMENT_FILES',
      'BARCODE_READ',
      'BARCODE_WRITE',
      'MYTOMRA_CHARITIES_READ',
      'MYTOMRA_CHARITIES_WRITE',
      'MYTOMRA_CHARITIES_BACKOFFICE',
      'manage-account',
      'manage-account-links',
      'view-profile'
    ],
    email: 'elin.sunde.wilberg@tomra.com'
  }
  refreshTokenParsed = {}
  idTokenParsed = {}

  init(_options?: any): Promise<boolean> {
    return Promise.resolve(this.authenticated)
  }

  logout(): Promise<void> {
    return Promise.resolve()
  }

  updateToken(_minValidity?: number): Promise<boolean> {
    return Promise.resolve(true)
  }
}

/**
 * Setup authentication for Playwright tests
 * This mimics the Cypress setup by setting window.CYPRESS and window.Cypress
 * which triggers the MockKeycloak in the application's authentication.ts
 */
export async function setupAuth(page: Page): Promise<void> {
  // Inject the CYPRESS flag and mock before the page loads
  await page.addInitScript(() => {
    // @ts-ignore
    window.Cypress = true
    // @ts-ignore
    // Mock tomraMenu to prevent "Cannot read properties of undefined (reading 'mount')" error
    window.tomraMenu = {
      mount: (_token: string) => {
        // No-op for tests
      }
    }
  })
}
